/**
 * Product shipping estimate card.
 *
 * Fills in the dispatch date and the free-shipping cutoff countdown for
 * every [data-weekdays] shipping card on the page.
 *
 * Locale month/weekday names come from the block settings rather than
 * toLocaleDateString so the merchant keeps control of the abbreviations.
 */
(() => {
  const pad = (value) => String(value).padStart(2, '0');

  function formatDispatchDate(card) {
    const weekdays = (card.dataset.weekdays || '').split(',');
    const months = (card.dataset.months || '').split(',');
    const daysAhead = parseInt(card.dataset.daysAhead, 10) || 0;

    const date = new Date();
    date.setDate(date.getDate() + daysAhead);

    const weekday = (weekdays[date.getDay()] || '').trim();
    const month = (months[date.getMonth()] || '').trim();

    return `${weekday}, ${date.getDate()} ${month}`;
  }

  /** Milliseconds until the next occurrence of the cutoff hour. */
  function timeUntilCutoff(cutoffHour) {
    const now = new Date();
    const cutoff = new Date();

    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (cutoff <= now) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    return cutoff - now;
  }

  function renderCountdown(element, cutoffHour) {
    const remaining = Math.max(0, timeUntilCutoff(cutoffHour));
    const totalSeconds = Math.floor(remaining / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    element.textContent = `${hours}h ${pad(minutes)}min ${pad(seconds)}s`;
  }

  function init() {
    const cards = Array.from(document.querySelectorAll('.product-shipping-estimate'));

    if (cards.length === 0) return;

    cards.forEach((card) => {
      const dateElement = card.querySelector('[data-shipping-date]');
      const countdownElement = card.querySelector('[data-shipping-countdown]');

      if (dateElement) {
        dateElement.textContent = formatDispatchDate(card);
      }

      if (countdownElement) {
        const cutoffHour = parseInt(card.dataset.cutoffHour, 10) || 0;

        renderCountdown(countdownElement, cutoffHour);
        setInterval(() => renderCountdown(countdownElement, cutoffHour), 1000);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
